export default {
	data() {
		return {
			moduleName: 'protocols',
			detailPageRouteName: 'protocolDetail',
			entity: {
				drm_system: 'none',
				container_format: 'mpegts',
				encryption_scheme: null,
				backend_config: null,
				max_player_ttl_seconds: null,
			},
			updateFields: [
				'name', 'code', 'prefix', 'port',
				'drm_system', 'container_format', 'encryption_scheme', 'backend_config', 'max_player_ttl_seconds',
			],
		}
	},
	methods: {
		filterFormParams(params) {
			let allowed = {}
			this._.forOwn(params, function (value, key) {
				if (this.updateFields.includes(key)) {
					allowed[key] = value
				}
			}.bind(this))
			return allowed
		},
		resetFields() {
			this.$refs['protocolformref'].validateProtocolFormRequiredFields()
			this.$refs['protocolformref'].$refs['nameref'].setTouched(false)
			this.$refs['protocolformref'].$refs['coderef'].setTouched(false)
			this.$refs['protocolformref'].$refs['prefixref'].setTouched(false)
		},
		processErrorMessage(error) {
			let errorMessage = null;
			this.$refs['protocolformref'].validateProtocolFormRequiredFields()

			this._.forEach(error['validation_errors'], function (message) {
				if (message.match("^Name \"(.+)\" is not unique\.$")) {
					errorMessage = this.$gettext('Název protokolu musí být unikátní.');
					this.$refs['protocolformref'].$refs['nameref'].setForcedInvalid(true, this.$gettext('Název není unikátní'));
				} else if (message.match("^Code \"(.+)\" is not unique\.$")) {
					errorMessage = this.$gettext('Kód protokolu musí být unikátní.');
					this.$refs['protocolformref'].$refs['coderef'].setForcedInvalid(true, this.$gettext('Kód není unikátní'));
				} else if (message === "Code can contains only alphanumeric characters, dash and underscore!") {
					errorMessage = this.$gettext("Kód smí obsahovat pouze znaky [a-ZA-Z0-9-_].");
					this.$refs['protocolformref'].$refs['coderef'].setForcedInvalid(true, this.$gettext('Kód smí obsahovat pouze znaky [a-ZA-Z0-9-_].'));
				}
			}.bind(this))

			return error['error_message'] = errorMessage || error['error_message'];
		},
		_processDetailErrorMessage(error) {
			let deleteError = null
			this._.forEach(error['validation_errors'], function (errorMessage) {
				deleteError = errorMessage;
			}.bind(this))

			if (deleteError) {
				error['error_message'] = deleteError
			}

			return error['error_message']
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/views/protocols/mixins/protocols.js